import {Injectable} from "@angular/core";

@Injectable()
export class TourSectionEffects {

  constructor() {
  }

}
